import * as React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip from Material-UI
import { API_BASE_URL } from '../../config/apiConfig';
import { headerLogo, navigationArrow } from '../../assets/images';
import CatWithBag from '../../assets/cat_with_bag.png';

const shippingData = [
    {
        label: "Pin code",
    },
];

const addressData = [
    {
        label: "Your billing address",
    },
    {
        label: "Your shipping address",
    },
];

export function ShippingInfo() {
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = React.useState('yes');
    const [isLoading, setIsLoading] = React.useState(false);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [pinCode, setPinCode] = React.useState(''); // State variable for pin code

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const formData = new FormData(event.target);
        const billingAddress = event.target['Your billing address-input'].value;
        const shippingAddress = event.target['Your shipping address-input'].value;

        if (!pinCode || !billingAddress || (selectedOption === 'no' && !shippingAddress)) {
            setSnackbarMessage('Pin code, billing address, and shipping address (if applicable) are required.');
            setSnackbarOpen(true);
            setIsLoading(false);
            return;
        }

        const token = sessionStorage.getItem('token');
        if (token) {
            const res = await fetch(API_BASE_URL + '/user/update-profile', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: token
                },
                body: JSON.stringify({
                    address: shippingAddress,
                    pincode: Number(pinCode),
                    professionAddress: billingAddress
                })
            });
            
            setIsLoading(false);
            if (res.ok) {
              sendWelcomeEmail();
                navigate('/profile', { state: { fromShipping: true } });
            }
        }
    }

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    const sendWelcomeEmail = async () => {
        const token = sessionStorage.getItem('token');
        const email = sessionStorage.getItem('email');
        const name = sessionStorage.getItem('name');
        if (token) {
            try {
                const response = await fetch(`${API_BASE_URL}/user/send-welcome-email`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    },
                    body: JSON.stringify({ email, name })
                });

                if (!response.ok) {
                    throw new Error('Failed to send welcome email.');
                }
            } catch (error) {
                console.error('Error sending welcome email:', error);
            }
        }
    };

    const handleSkip = async (event) => {
      event.preventDefault();
      console.log(pinCode);
      if (!pinCode) {
        setSnackbarMessage('Pin code is required.');
        setSnackbarOpen(true);
        setIsLoading(false);
        return;
      } else {
        const token = sessionStorage.getItem('token');
        if (token) {
          const res = await fetch(API_BASE_URL + '/user/update-profile', {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
              authorization: token
            },
            body: JSON.stringify({
              pincode: Number(pinCode),
            })
          });
          console.log(res);
          setIsLoading(false);
          if (res.ok) {
            setSelectedOption('yes'); // Reset to default option
            setSnackbarMessage('You have skipped the shipping information.'); // Optional message
            setSnackbarOpen(true); // Show snackbar message
            setIsLoading(false);
            sendWelcomeEmail();
            navigate('/profile', { state: { fromShipping: true } });
          }
        }
      }
   // }
  
    // Clear any existing form data or state if necessary
    /* setSelectedOption('yes'); // Reset to default option
    setSnackbarMessage('You have skipped the shipping information.'); // Optional message
    setSnackbarOpen(true); // Show snackbar message
    setIsLoading(false);
    sendWelcomeEmail();
    navigate('/profile', { state: { fromShipping: true } }); */
  };

    return (
        <MainContainer>
            <ContentWrapper>
                <LeftColumn>
                    <LeftColumnContent>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'10px'}}>
                            <Logo onClick={() => navigate("/")} src={headerLogo} alt="Logo" />
                        </div>
                        <Heading>Shipping <br />info</Heading>
                        <StepIndicator>Step 04 / 04
                        <Tooltip title="Click here to more about us.." arrow>
                                <InfoIcon onClick={() => navigate("/about")}>
                                <InfoOutlinedIcon style={{ width: '16px', height: '16px',backgroundColor:'#e9fe53', borderRadius:'100px'}} />
                                </InfoIcon>
                            </Tooltip>
                        </StepIndicator>
                        <ProgressBar>
                            <ProgressIndicator />
                        </ProgressBar>
                        <NextStep>You’re just one step away from unlocking your curated deals.</NextStep>
                    </LeftColumnContent>
                </LeftColumn>
                <RightColumn>
                    <FormContainer onSubmit={handleSubmit}>
                        <RelativeFormWrapper onSubmit={handleSubmit}>
                            <FormFields>
                                {shippingData.map((field, index) => (
                                    <FormField key={index}>
                                        <Label htmlFor={`${field.label}-input`}>{field.label}</Label>
                                        <Input
                                            type="text"
                                            id={`${field.label}-input`}
                                            value={pinCode} // Bind the input value to pinCode state
                                            onChange={(e) => setPinCode(e.target.value)} // Update pinCode state on change
                                        />
                                    </FormField>
                                ))}
                                <BillingAddressField>
                                    <BillingAddressLabel>
                                        Is your shipping address same as your billing address?
                                    </BillingAddressLabel>
                                    <BillingAddressOptions>
                                        <BillingAddressOption onClick={() => handleOptionChange('yes')}>
                                            <RadioButton isSelected={selectedOption === 'yes'} />
                                            <span>Yes</span>
                                        </BillingAddressOption>
                                        <BillingAddressOption onClick={() => handleOptionChange('no')}>
                                            <RadioButton isSelected={selectedOption === 'no'} />
                                            <span>No</span>
                                        </BillingAddressOption>
                                    </BillingAddressOptions>
                                </BillingAddressField>
                            </FormFields>
                            <AddressFields>
                                {addressData.map((field, index) => (
                                    <AddressField key={index}>
                                        <AddressLabel htmlFor={`${field.label}-input`}
                                            style={{ display: selectedOption === 'yes' && field.label === "Your shipping address" ? 'none' : 'block' }}>
                                            {field.label}
                                        </AddressLabel>
                                        <AddressInput
                                            type="text"
                                            id={`${field.label}-input`}
                                            disabled={selectedOption === 'yes' && field.label === "Your shipping address"}
                                            style={{ display: selectedOption === 'yes' && field.label === "Your shipping address" ? 'none' : 'block' }}
                                        />
                                    </AddressField>
                                ))}
                            </AddressFields>
                            <ButtonContainer>
                                <SkipButton type="button" onClick={handleSkip}>
                                    Skip
                                    <ArrowIcon src={navigationArrow} alt="Arrow Icon" />
                                </SkipButton>
                                <SubmitButton type="submit" disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} /> : <ButtonText>Submit</ButtonText>}
                                    <ArrowIcon src={navigationArrow} alt="Arrow Icon" />
                                </SubmitButton>
                            </ButtonContainer>
                            <CatWithBagImage src={CatWithBag} alt="Cat with Bag" />
                        </RelativeFormWrapper>
                    </FormContainer>
                </RightColumn>
            </ContentWrapper>
            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <FooterWrapper>
                <NavigationLinks>
                    <Link onClick={() => window.open("/", "_blank")}>Home</Link>
                    <Link onClick={() => window.open("/about", "_blank")}>About Us</Link>
                </NavigationLinks>
                <Copyright>
                    Copyright © 2024. SPOELT. All rights reserved
                </Copyright>
            </FooterWrapper>
        </MainContainer>
    );
}

const MainContainer = styled.main`
  background-color: #fff;
  padding: 39px 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;
const LeftColumn = styled.section`
  width: 35%;
  margin-left: 0;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const LeftColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

const Logo = styled.img`
  width: 130px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer; // Added cursor pointer for logo
`;
const InfoIcon = styled.div`
  width: 10px; // Adjust size as needed
  margin-left: 5px; // Space between text and icon
  cursor: pointer; // Added cursor pointer for info icon
`;
const Heading = styled.h1`
  color: #202023;
  margin-top: 129px;
  font: 800 60px/65px Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 30px;
    margin-bottom: 10px;    font-size: 40px;
    line-height: 48px;
  }
`;

const StepIndicator = styled.p`
display: flex;
flex-direction: row;
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 30px;
  font: 400 12px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const ProgressBar = styled.div`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  margin-top: 8px;
  padding: 1px 0;
  @media (max-width: 991px) {
    //padding-right: 20px;
  }
`;

const ProgressIndicator = styled.div`
  background-color: #e9fe53;
  width: 100%;
  height: 12px;
`;

const NextStep = styled.p`
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 9px;
  font: 400 12px/130% Metrophobic, sans-serif;
`;

const RightColumn = styled.section`
  width: 65%;
  margin-left: 20px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
`;

const ShippingForm = styled.section`
  display: flex;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const FormContainer = styled.div`
display: flex;
margin-top: 69px;
flex-grow: 1;
flex-direction: column;
@media (max-width: 991px) {
  max-width: 100%;
  margin-top: 10px;
}
`;
const FormWrapper = styled.form`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  flex-direction: column;
  padding: 53px 40px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;
const FormFields = styled.div`
  display: flex;
  gap: 20px;
  color: #202023;
  font-weight: 400;
  @media (max-width: 991px) {
    flex-wrap: wrap;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  line-height: 130%;
  flex-grow: 1;
  flex-basis: 0;
  width: fit-content;
`;

const Label = styled.label`
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
    padding: 0;
  }
    max-width: 100%;
    padding: 0 20px;
  }
`;

const Input = styled.input`
padding-left: 10px;
padding-right: 10px;
font:  16px/130% Metrophobic, sans-serif;

  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  margin-top: 10px;
  height: 50px;
`;

const BillingAddressField = styled.div`
  align-self: start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;
  width: fit-content;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const BillingAddressLabel = styled.div`
  letter-spacing: -0.24px;
  text-transform: uppercase;
  font: 12px/16px Metrophobic, sans-serif;
`;

const BillingAddressOptions = styled.div`
  border-radius: 1px;
  display: flex;
  margin-top: 12px;
  padding-right: 80px;
  gap: 20px;
  font-size: 16px;
  white-space: nowrap;
  letter-spacing: -0.32px;
  line-height: 130%;
  @media (max-width: 991px) {
    padding-right: 20px;
    white-space: initial;
  }
`;

const BillingAddressOption = styled.div`
  display: flex;
  gap: 9px;
  padding: 3px 0;
  cursor: pointer;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const RadioButton = styled.div`
width: 8px;
height: 8px;
fill: #e9fe53;
border: 1px solid #000; /* Default state */
border-radius: 50%;
padding: 5px;
background-color: ${props => props.isSelected ? "#e9fe53" : "transparent"};
position: relative; /* Added for positioning the tick mark */
&:after {
  content: ${props => props.isSelected ? "'✓'" : "''"};
  color: #202023;
  font-size: 12px;
  position: absolute;
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust for the size of the tick */
}
`;

const AddressFields = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 20px;
  flex-direction: row;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 20px;
    flex-direction: column;
  }
`;

const AddressField = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const AddressLabel = styled.label`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  font-size: 12px;
  color: #202023;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  line-height: 130%;
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 0px;
  }
`;

const AddressInput = styled.textarea`
padding-left: 10px;
padding-right: 10px;
font:  16px/130% Metrophobic, sans-serif;

  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  margin-top: 10px;
  height: 105px;
  @media (max-width: 991px) {
   
  }
`;

const SubmitButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  background-color: #e9fe53;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  width: 50%;
  max-width: 100%;
  gap: 8px;
  font-size: 16px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  line-height: 130%;
  padding: 15px 13px;
  @media (max-width: 991px) {
    padding-right: 20px;
    white-space: initial;
    margin-bottom: 20px;
  }
`;

const SkipButton = styled.button`
border: 1px solid rgba(32, 32, 35, 1);
border-radius: 1px;
background-color: #fff;
display: flex;
justify-content: space-between;
margin-top: 40px;
margin-right:10px;
width: 50%;
max-width: 100%;
gap: 8px;
font-size: 16px;
color: #202023;
text-transform: uppercase;
letter-spacing: -0.32px;
line-height: 130%;
padding: 15px 13px;
@media (max-width: 991px) {
  padding-right: 20px;
  white-space: initial;
  margin-bottom: 20px;
}
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center; /* Center buttons vertically */
  margin-top: 20px; /* Space above buttons */
`;

const ButtonText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const ArrowIcon = styled.img`
  width: 11px;
  fill: #202023;
  margin: auto 0;
`;

const Copyright = styled.p`
  color: #828282;
  align-self: flex-end;
  margin-top: 53px;
  font: 400 12px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 40px;
    align-self: center;
  }
`;

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  //padding: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const NavigationLinks = styled.div`
  display: flex;
  justify-content: left;
  gap: 20px;
  margin-top: auto;
  margin-bottom:5px;
 
  font: 600 22px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font: 600 16px Metrophobic, sans-serif;
    margin-top: 40px;
    align-self: center;
  }
`;

const Link = styled.span`
  color: #202023;
  cursor: pointer;
`;

const RelativeFormWrapper = styled(FormWrapper)`
  position: relative;
`;

const CatWithBagImage = styled.img`
  position: absolute;
  top: 20%; /* Adjust as needed */
  right: -90px; /* Adjust as needed */
  width: 130px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;